import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBroadcast = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66667 6.66667C2.12296 7.59671 1.90276 8.6807 2.04048 9.74917C2.1782 10.8176 2.66609 11.8104 3.42786 12.5721C4.18964 13.3339 5.18236 13.8218 6.25083 13.9595C7.3193 14.0972 8.40329 13.877 9.33333 13.3333L2.66667 6.66667Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 10L8 8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3333 8.66667C11.3333 7.6058 10.9119 6.58839 10.1618 5.83824C9.41162 5.08809 8.3942 4.66667 7.33333 4.66667",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 8.66667C14 6.89856 13.2976 5.20286 12.0474 3.95262C10.7971 2.70238 9.10144 2 7.33333 2",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBroadcast;
